import type { CityConfig } from "../city-template/types";

export const valparaisoConfig: CityConfig = {
  city: "Valparaiso",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "valparaiso",
  route: "/cities/valparaiso",
  title: "Emergency Passport Valparaiso, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Valparaiso, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Valparaiso, Portage, Chesterton, Porter, and all Porter County residents. A+ BBB rated courier service with access to the Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Valparaiso, IN",
  heroSubtitle: "Valparaiso travelers — from Valparaiso University students heading abroad to Porter County professionals commuting to Chicago and families visiting Indiana Dunes National Park before international trips — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, under an hour away.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Valparaiso%20Indiana%20historic%20downtown%20courthouse%20square%20with%20the%20Porter%20County%20Courthouse%20clock%20tower%20at%20golden%20hour%2C%20Valparaiso%20University%20Chapel%20of%20the%20Resurrection%20with%20its%20striking%20modern%20architecture%2C%20the%20charming%20Lincolnway%20downtown%20district%20with%20brick%20storefronts%20and%20tree-lined%20streets%2C%20Indiana%20Dunes%20National%20Park%20Lake%20Michigan%20shoreline%20in%20the%20distance%2C%20warm%20amber%20and%20gold%20sunset%20light%20with%20historic%20small-town%20charm%20and%20natural%20beauty%2C%20atmospheric%20cinematic%20photography%20with%20rich%20tones%2C%20no%20text%20or%20people%2C%20wide%20landscape%20composition&width=1800&height=700&seq=valparaiso-hero-001&orientation=landscape",
  heroImageAlt: "Valparaiso Indiana with historic courthouse square and Valparaiso University at golden sunset",
  geoPosition: "41.4731;-87.0611",
  geoPlacename: "Valparaiso, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604, IL 60605",
    distance: "Approximately 55 miles northwest of Valparaiso — about 50–60 minutes via I-65, I-94, and the Chicago Skyway",
  },
  nearbyCitiesZips: [
    { name: "Valparaiso", zips: "46383, 46384, 46385" },
    { name: "Portage", zips: "46368" },
    { name: "Chesterton", zips: "46304" },
    { name: "Porter", zips: "46304" },
    { name: "Wheeler", zips: "46393" },
    { name: "Kouts", zips: "46347" },
    { name: "Hebron", zips: "46341" },
    { name: "Wanatah", zips: "46390" },
    { name: "Merrillville", zips: "46410" },
    { name: "Westville", zips: "46391" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Direct courier to Chicago Passport Agency — under an hour from Valparaiso via I-65 and the Skyway" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Porter County" },
    { icon: "ri-building-line", title: "Northwest Indiana Access", desc: "Serving Valparaiso, Portage, Chesterton, and all Porter County communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — or same-day hand delivery to Chicago Passport Agency" },
  ],
  internalLinks: [
    { name: "Expedited passport in Gary, IN", route: "/gary" },
    { name: "Emergency passport help in Hammond, IN", route: "/cities/hammond-in" },
    { name: "Passport services in Merrillville, IN", route: "/cities/merrillville" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Valparaiso, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 55 miles — about 50–60 minutes via I-65, I-94, and the Chicago Skyway. Valparaiso's location in Porter County, nestled between Indiana Dunes National Park and the greater Chicagoland region, makes it a natural fit for expedited passport service with Chicago agency access.",
  fpcOfficeDistance: "Serving Valparaiso, Portage, Chesterton, Porter, Wheeler, Kouts, Hebron, Wanatah, Westville, and all of Porter County and Northwest Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Valparaiso and Porter County. From the Valparaiso University campus and the historic downtown courthouse square to the Indiana Dunes National Park gateway communities of Chesterton and Porter — we serve all of Porter County with direct access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Valparaiso and all nearby communities including Portage, Chesterton, Porter, Wheeler, Kouts, Hebron, Wanatah, and Westville. We also serve all of Porter County and the greater Northwest Indiana/Chicagoland region.",
  howItWorksIntro: "Most Valparaiso travelers complete everything online and ship documents overnight. Because the Chicago Passport Agency is under an hour away via I-65 and the Skyway, our courier can often hand-deliver the same day — making Valparaiso one of the best-positioned Indiana cities for expedited passport service.",
  mistakesIntro: "Valparaiso is uniquely positioned in Porter County near Indiana Dunes National Park and within an hour of downtown Chicago. Here are the most common passport mistakes we see from Porter County travelers.",
  testimonialsIntro: "Valparaiso travelers — from Valpo University students to Porter County families to Indiana Dunes visitors — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Valparaiso, IN? Here are the most common ones we hear from Porter County and Northwest Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — under an hour from Valparaiso", "Fastest access to a passport agency in Porter County", "Ideal for Valparaiso University students and faculty", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — under an hour from Valparaiso", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Chicago Passport Agency in person", "50–60 minute drive from Valparaiso via I-65 and Skyway"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Valparaiso travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Chicago Passport Agency — under an hour from Valparaiso via I-65 and the Skyway.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — under an hour from Porter County", "Valparaiso University student and family support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Valparaiso adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle the Chicago agency delivery.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier to Chicago Passport Agency", "Returned to your Porter County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Valparaiso residents — including Valpo University students and young adults in the Porter County region.",
      bullets: ["Acceptance facility scheduling in Valparaiso or Portage", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Valparaiso residents who lost their passport before international travel — fast turnaround leveraging Chicago proximity.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Valparaiso and Porter County families traveling internationally with children.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Valparaiso and Porter County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Valparaiso IN", description: "Urgent passport processing for Valparaiso Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Valparaiso IN", description: "Fast passport renewal for Valparaiso Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Valparaiso IN", description: "New passport application services for Valparaiso Indiana residents applying for their first passport." },
    { name: "Child Passport Valparaiso IN", description: "Minor passport services for Valparaiso Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Valparaiso, IN — Valpo University",
      rating: 5,
      text: "Semester abroad in Chile through Valpo's international program — realized my passport was expired 10 days before departure. Fast Passport Center got it renewed in 3 days through the Chicago agency. Saved my entire semester. Incredible.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Tom H.",
      location: "Chesterton, IN",
      rating: 5,
      text: "Family trip to the UK — needed passports for four of us. Fast Passport Center handled everything in 5 days with the Chicago agency so close. The Porter County convenience is unbeatable. Smooth from start to finish.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rachel S.",
      location: "Valparaiso, IN — Downtown",
      rating: 5,
      text: "Business conference in Toronto with 6 days notice. Expired passport. Fast Passport Center came through in 48 hours. Chicago is under an hour from Valpo — the courier advantage is real and saved my career moment.",
      service: "Emergency Passport",
    },
    {
      name: "Mike D.",
      location: "Portage, IN",
      rating: 5,
      text: "Lost my passport right before a trip to Ireland. Panic mode. Fast Passport Center replaced it in 2 days. The Chicago Passport Agency proximity is a superpower for Porter County residents. Can't recommend enough.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "valparaiso-1",
      name: "Valparaiso Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Valparaiso St",
      city: "Valparaiso",
      state: "IN",
      zip: "46383",
      phone: "(219) 462-5191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Valparaiso, near Valparaiso University campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Valparaiso acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient location near Valparaiso University and the downtown courthouse square.",
      icon: "ri-mail-line",
    },
    {
      id: "valparaiso-2",
      name: "Portage Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Hamstrom Rd",
      city: "Portage",
      state: "IN",
      zip: "46368",
      phone: "(219) 762-5364",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Portage, approximately 10 miles west of downtown Valparaiso",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern Porter County acceptance facility. Convenient for Portage, Ogden Dunes, and northern Porter County residents. Near Indiana Dunes National Park access.",
      icon: "ri-mail-line",
    },
    {
      id: "valparaiso-3",
      name: "Chesterton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1070 S Calumet Rd",
      city: "Chesterton",
      state: "IN",
      zip: "46304",
      phone: "(219) 926-1286",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chesterton, approximately 5 miles north of Valparaiso",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Porter County acceptance facility in Chesterton. Serves Indiana Dunes National Park visitors and northern Porter County communities. Call to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "valparaiso-4",
      name: "Porter County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "16 Lincolnway, Suite 209",
      city: "Valparaiso",
      state: "IN",
      zip: "46383",
      phone: "(219) 465-3450",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Valparaiso, Porter County Administration Building",
      website: "https://www.porterco.org/",
      websiteLabel: "Porter County",
      notes: "Porter County Clerk's office at the Administration Building. Extended morning hours compared to post offices. Call to confirm current passport acceptance hours. Serves all of Porter County.",
      icon: "ri-government-line",
    },
    {
      id: "valparaiso-5",
      name: "Merrillville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "303 W 80th Pl",
      city: "Merrillville",
      state: "IN",
      zip: "46410",
      phone: "(219) 769-3924",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Merrillville, approximately 15 miles west of Valparaiso",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Lake County facility convenient for western Porter County border residents. Near Southlake Mall area. Good alternative when Valparaiso appointments are booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 50–60 minutes to Chicago via I-65 and Skyway", fpc: "No — we deliver for you, same-day handoff" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Porter County Advantage", agency: "Valparaiso is one of the closest Indiana cities to a passport agency", fpc: "We leverage the under-an-hour Chicago proximity for every client" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Valparaiso's proximity to Chicago (under an hour) creates a false sense of security. Even though the Chicago Passport Agency is close, you still need an appointment — and they don't accept walk-ins. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Valparaiso and Chesterton sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background — no exceptions, no glasses, no shadows.",
    },
    {
      icon: "ri-roadster-line",
      title: "Underestimating Chicago Drive Time",
      description: "The route to the Chicago Passport Agency involves I-65, I-94, and the Chicago Skyway — all of which can experience heavy congestion during rush hours, summer weekends (Dunes traffic), and Chicago events. A 50-minute drive can easily become 90+ minutes. Our courier service eliminates this stress.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Valpo study abroad students heading to Europe and Porter County travelers visiting Mexico or Canada often discover this requirement too late.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Expecting Services at Indiana Dunes National Park",
      description: "The Indiana Dunes National Park visitor center does NOT offer passport services. Travelers visiting the Dunes before international trips sometimes assume the national park facility can help — it can't. Use Valparaiso, Portage, or Chesterton acceptance facilities.",
    },
    {
      icon: "ri-file-list-line",
      title: "Not Preparing for Both Parents Requirement",
      description: "For child passport applications in Valparaiso, both parents must generally appear together at the acceptance facility. Porter County families sometimes arrive with only one parent and get turned away. Plan for both parents to attend.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Valparaiso or Porter County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Valparaiso, Portage, or Chesterton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Porter County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — under an hour from Valparaiso via I-65 and the Skyway." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Valparaiso address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Valparaiso, IN?", a: "Fast Passport Center offers emergency passport processing in Valparaiso, Indiana in as little as 24–48 hours. Because the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) is only about 55 miles — under an hour via I-65, I-94, and the Chicago Skyway — our registered couriers can hand-deliver your documents faster than almost any other location in Indiana." },
    { q: "Does Valparaiso have its own passport agency?", a: "No — Valparaiso does not have its own passport agency. However, Valparaiso residents benefit from the Chicago Passport Agency being only about 55 miles away — a 50–60 minute drive via I-65 and the Chicago Skyway. This is one of the closest distances any Indiana city has to a regional passport agency, rivaled only by Gary and Hammond." },
    { q: "Is Valparaiso one of the fastest Indiana cities for passport service?", a: "Absolutely. Valparaiso's proximity to the Chicago Passport Agency (under an hour via the Skyway) makes it one of the fastest cities in Indiana for emergency passport service. Only Gary and Hammond are marginally closer to Chicago. For Porter County travelers, this is a massive advantage." },
    { q: "What airports do Valparaiso travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is approximately 75 minutes via I-65/I-294, and Chicago Midway International Airport (MDW) is about 60 minutes via I-65/I-94. Both offer extensive international flight options. South Bend International Airport (SBN) is approximately 45 minutes east for domestic connections." },
    { q: "How much does an expedited passport cost in Valparaiso, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Valparaiso?", a: "Walgreens (2050 N Calumet Ave, Valparaiso), CVS (2307 N Calumet Ave, Valparaiso), and Walmart (2400 Morthland Dr, Valparaiso) offer passport photo services. The UPS Store in Valparaiso also provides passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Valparaiso University students and faculty?", a: "Yes. We serve Valparaiso University students, faculty, and staff for study abroad programs, faculty research travel, international conferences, and mission trips. Valpo's Office of International Programs recommends starting passport applications well in advance — but we can help with last-minute emergencies." },
    { q: "Can I combine a passport appointment with an Indiana Dunes National Park visit?", a: "Yes! Valparaiso is just minutes from Indiana Dunes National Park. You can schedule your acceptance facility appointment in Valparaiso, Portage, or Chesterton, then enjoy the Dunes before or after. Just note that the park visitor center does not offer passport services — you need a dedicated acceptance facility." },
  ],
  photoLocations: [
    { name: "Walgreens — Valparaiso", address: "2050 N Calumet Ave, Valparaiso, IN 46383", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Valparaiso", address: "2307 N Calumet Ave, Valparaiso, IN 46383", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walmart — Valparaiso", address: "2400 Morthland Dr, Valparaiso, IN 46383", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Valparaiso", address: "2305 N Calumet Ave, Valparaiso, IN 46383", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Valparaiso", address: "3125 Calumet Ave, Valparaiso, IN 46383", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient location on Calumet Avenue near Valparaiso Marketplace shopping center.", featured: true },
    { name: "Indiana BMV — Portage", address: "6043 Central Ave, Portage, IN 46368", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Portage. Full REAL ID processing available. Serves northern Porter County and Indiana Dunes gateway communities.", featured: false },
  ],
  airports: [
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "60 minutes west of Valparaiso via I-65/I-94",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with extensive domestic and Caribbean/Mexico connections. Usually the fastest Chicago airport to reach from Porter County. Great for Porter County casual travelers.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "75 minutes west of Valparaiso via I-65/I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "One of the world's busiest airports. United and American Airlines hubs with global connections to Europe, Asia, Middle East, and South America. The primary international gateway for Northwest Indiana travelers.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "SBN",
      name: "South Bend International Airport",
      distance: "45 minutes east of Valparaiso",
      address: "4477 Progress Dr, South Bend, IN 46628",
      note: "Regional airport serving northern Indiana. Domestic connections via major carriers to hubs like Atlanta, Detroit, Charlotte, and Minneapolis. Good for domestic first-leg flights.",
      flightUrl: "https://flysbn.com/",
      flightLabel: "SBN Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Porter County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Porter County and all Indiana counties" },
    { label: "Porter County Clerk: Marriage Licenses", url: "https://www.porterco.org/", icon: "ri-heart-line", description: "Porter County Clerk — marriage license records for Valparaiso and Porter County" },
    { label: "Porter County: Divorce Decrees", url: "https://www.porterco.org/", icon: "ri-file-list-3-line", description: "Porter County Clerk of Courts — divorce decree records for Valparaiso and Porter County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Valparaiso address" },
  ],
};